import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';

import QuizControl from './QuizControl';
import QuizGreeting from './QuizGreeting';


class Quiz extends Component {
  constructor(props) {
    super(props);

    this.state = {
      started: false,
      audioLoaded: false,
      enableAudio: props.enableAudio || false,
    };
  }

  get unavailable() {
    return this.props.disableStart || (this.state.enableAudio && !this.state.audioLoaded);
  }

  componentDidMount() {
    if (this.props.autoStart && !this.state.started && !this.unavailable) {
      setTimeout(() => this.start(), 0);
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.autoStart && this.props.autoStart && !this.state.started && !this.unavailable) {
      setTimeout(() => this.start(), 0);
    }
  }

  start() {
    this.setState({
      started: true,
    }, () => {
      if (!this.props.onStart) {
        return
      }
      this.props.onStart()
    });
  }

  quizFinish(e) {
    if (!this.props.onFinish) {
      return;
    }
    this.props.onFinish(e);
  }

  enableAudioChanged(enableAudio) {
    this.setState({
      enableAudio,
    });
  }

  audioLoaded(ev) {
    this.setState({
      audioLoaded: true,
    }, () => {
      if (!this.props.audioLoaded) {
        return;
      }
      this.props.audioLoaded(ev);
    });
  }

  render() {
    return (
      <div>
        {!this.state.started &&
          <div className='StartPanel'>
            <QuizGreeting
              enableAudio={this.state.enableAudio}
              disableAudio={this.props.disableAudio}
              hideTitle={this.props.hideTitle}
              hideCaution={this.props.hideCaution}
              enableAudioChanged={enableAudio => this.enableAudioChanged(enableAudio)} />
            <Button
              variable="success"
              disabled={this.props.disableStart || (this.state.enableAudio && !this.state.audioLoaded)}
              onClick={ev => this.start()}>
              {this.state.enableAudio && !this.state.audioLoaded ? '読み込み中...' : 'はじめる'}
            </Button>
          </div>}
        <QuizControl
          started={this.state.started}
          data={this.state.data || this.props.data}
          examples={this.state.examples || this.props.examples}
          enableAudio={this.state.enableAudio}
          audioURL={this.props.audioURL}
          audioLoaded={ev => this.audioLoaded(ev)}
          onFinish={e => this.quizFinish(e)}
          disableProblemReport={this.props.disableProblemReport}
          problemReported={this.props.problemReported}
        />
      </div>
    );
  }
}

export default Quiz;
